import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";
const apiEndpoint = API_BASE_URL_ENV() + "/admin/compound/interactives";

const apiEndpointCreate =
	API_BASE_URL_ENV() + "/admin/compound/add-interactive";
const apiDropDownEndpoint =
	API_BASE_URL_ENV() + "/admin/compound/get-all-properities/";
const api = API_BASE_URL_ENV() + "/admin/compound/get-shapes?compound_id=";

const apiSite = API_BASE_URL_ENV() + "/site/get-shapes?compound_id=";
const interactiveCompoundApi =
	API_BASE_URL_ENV() + "/admin/compound/interactive-compounds";
const toggleApi =
	API_BASE_URL_ENV() + "/admin/compound/toggle-activation/InterActive";
export default class extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
	getBuildingUnit = (id) => {
		return http.get(`${apiDropDownEndpoint}${id}?status=1`);
	};
	getInteractiveMode = (id) => {
		return http.get(`${api}${id}`);
	};
	getInteractiveModeSite = (id) => {
		return http.get(`${apiSite}${id}`);
	};

	getCompoundsInteractives = () => {
		return http.get(interactiveCompoundApi);
	};

	toggleStatus = (id) => {
		return http.get(`${toggleApi}/${id}`);
	};
}
